/**
 * O valor de cada tag é contrato com o time de dados: renomeie o identificador
 * TypeScript, nunca a string.
 */
export const ONBOARDING_NCA_TAGS = {
  CNPJ_CARREGADO: 'onboarding_nca_cnpj_carregado',
  AUTORIZACAO_VISUALIZADA: 'onboarding_nca_autorizacao_visualizada',
  AUTORIZACAO_CONFIRMADA: 'onboarding_nca_autorizacao_confirmada',
} as const;

export type OnboardingNcaTag =
  typeof ONBOARDING_NCA_TAGS[keyof typeof ONBOARDING_NCA_TAGS];
